import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export const useTooltipStyles = makeStyles(() =>
  createStyles({
    tooltip: {
      marginTop: 10,
    },
  }),
);

export default makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
      paddingBottom: theme.spacing(1),
    },
    inputLabel: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(20),
      color: theme.palette.greyText.main,
    },
    tooltipIcon: {
      fontSize: theme.typography.pxToRem(17),
      color: theme.palette.greyText.main,
    },
  }),
);
